import Base from "@/api/Base";

export default class Listing extends Base
{
	setJob (v)
	{
		this.job = v;
		return this;
	}

	setFilterValues (v)
	{
		this.data.filterValues = v;
		return this;
	}

	setOnlyFavorites (v)
	{
		this.data.onlyFavorites = v;
		return this;
	}

	setOnlyExcluded (v)
	{
		this.data.onlyExcluded = v;
		return this;
	}

	setJobProfile (v)
	{
		this.data.jobProfile = v;
		return this;
	}

	setOffset (v)
	{
		this.data.offset = v;
		return this;
	}

	setLimit (v)
	{
		this.data.limit = v;
		return this;
	}

	getMethod ()
	{
		return 'POST';
	}

	getUrl ()
	{
		return '/job/' + this.job + '/listing';
	}
}
